import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

import { GET_ORGANIZATION_PERSONAL_API_KEYS } from "./gql";
import { OrganizationPersonalApiKeyRow } from "./types";

const useApiKeysPersonalData = () => {
  const { viewer } = useTypedContext(AccountContext);

  const { data, loading, error } = useQuery(GET_ORGANIZATION_PERSONAL_API_KEYS);

  const apiKeys = useMemo<OrganizationPersonalApiKeyRow[]>(
    () =>
      (data?.personalApiKeys ?? [])
        .filter((apiKey) => !apiKey.disabled)
        .map((apiKey) => ({ ...apiKey, isViewerKey: apiKey.owner === viewer.id })),
    [data?.personalApiKeys, viewer.id]
  );

  return { apiKeys, isInitialLoading: loading && !data, error };
};

export default useApiKeysPersonalData;
